import { addExternalScript } from '../../includes/utils';

/* ------------------------------------------------------------ */
/* -- Ad Init -- */
/* ------------------------------------------------------------ */
const adInit = () => {
  // const hasVideoAd = document.getElementById('protag-player');
  // if (!hasVideoAd) {
  //   return;
  // }
  // Load GPT and Ad scripts
  addExternalScript({ src: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js', async: true }).then(() => {
    window.googletag = window.googletag || { cmd: [] };
    window.googletag.cmd.push(function () {
        window.googletag.pubads().enableSingleRequest();
    });
  }).catch(err =>
    console.error(err),
  );
  addExternalScript({ src: 'https://cdn.nuload.net/businesscloud_co_uk/ad.js', async: true }).catch(err =>
    console.error(err),
  );
  addExternalScript({ src: 'https://protagcdn.com/s/businesscloud.co.uk/site.js', async: true }).then(() => {
    window.protag = window.protag || { cmd: [] };
    window.protag.cmd.push(function () {
        window.protag.pageInit();
    });
  }).then(() => { 
    window.googletag = window.googletag || { cmd: [] };
    window.protag = window.protag || { cmd: [] };
    window.protag.cmd.push(function () {
      window.protag.display("protag-player");
    });
  })
  .catch(err =>
    console.error(err),
  );
};

export default adInit;
